import { compose } from 'recompose';
import { injectIntl } from 'react-intl';
import { addIntlProps, addProps } from 'utils/recompose';
import messages from './messages';
import { connect } from 'react-redux';
import { productionPeriod } from 'reducers/dashboard/selectors';
import combineSelectors from 'utils/combineSelectors';

const mapStateToProps = combineSelectors({
  productionPeriod,
});

export const allocationTitle = ({ productionPeriod, allocationLabel }) =>
  `${productionPeriod} ${allocationLabel}`;

export default compose(
  injectIntl,
  addIntlProps({
    messages,
    propNames: ['allocationLabel'],
  }),
  connect(mapStateToProps),
  addProps({ allocationTitle }),
);
